import { render, staticRenderFns } from "./MypageFavoritePlayerSelectPane.vue?vue&type=template&id=16b65a9e&scoped=true"
import script from "./MypageFavoritePlayerSelectPane.vue?vue&type=script&lang=ts"
export * from "./MypageFavoritePlayerSelectPane.vue?vue&type=script&lang=ts"
import style0 from "./MypageFavoritePlayerSelectPane.vue?vue&type=style&index=0&id=16b65a9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b65a9e",
  null
  
)

export default component.exports